import React from 'react';
import { useIntl } from '@lumahealthhq/ui-components';
import { Box, Skeleton, Stack, TextField } from '@lumahealthhq/ui-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ContentLoading(_ref) {
  var hasCustomWrapper = _ref.hasCustomWrapper;
  var intl = useIntl();
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'grid',
      gridTemplateColumns: hasCustomWrapper ? '1fr' : '1fr auto',
      columnGap: 3
    },
    children: [/*#__PURE__*/_jsxs(Stack, {
      gap: 2,
      width: "100%",
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          gap: 2
        },
        children: [/*#__PURE__*/_jsx(TextField, {
          required: true,
          InputProps: {
            readOnly: true
          },
          fullWidth: true,
          label: intl.formatMessage({
            id: "DBP3Sx",
            defaultMessage: [{
              "type": 0,
              "value": "Subscriber firstname"
            }]
          })
        }), /*#__PURE__*/_jsx(TextField, {
          required: true,
          InputProps: {
            readOnly: true
          },
          fullWidth: true,
          label: intl.formatMessage({
            id: "jBWKPZ",
            defaultMessage: [{
              "type": 0,
              "value": "Subscriber lastname"
            }]
          })
        })]
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          gap: 2
        },
        children: [/*#__PURE__*/_jsx(TextField, {
          required: true,
          InputProps: {
            readOnly: true
          },
          fullWidth: true,
          label: intl.formatMessage({
            id: "GsJrCG",
            defaultMessage: [{
              "type": 0,
              "value": "Subscriber date of birth"
            }]
          })
        }), /*#__PURE__*/_jsx(TextField, {
          required: true,
          InputProps: {
            readOnly: true
          },
          fullWidth: true,
          label: intl.formatMessage({
            id: "Ruh5ZZ",
            defaultMessage: [{
              "type": 0,
              "value": "Relationship to subscriber"
            }]
          })
        })]
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          gap: 2
        },
        children: [/*#__PURE__*/_jsx(TextField, {
          required: true,
          InputProps: {
            readOnly: true
          },
          fullWidth: true,
          label: intl.formatMessage({
            id: "BSilTn",
            defaultMessage: [{
              "type": 0,
              "value": "Member ID"
            }]
          })
        }), /*#__PURE__*/_jsx(TextField, {
          InputProps: {
            readOnly: true
          },
          fullWidth: true,
          label: intl.formatMessage({
            id: "nBKj/i",
            defaultMessage: [{
              "type": 0,
              "value": "Group ID"
            }]
          })
        })]
      }), /*#__PURE__*/_jsx(TextField, {
        required: true,
        InputProps: {
          readOnly: true
        },
        fullWidth: true,
        label: intl.formatMessage({
          id: "A3zncm",
          defaultMessage: [{
            "type": 0,
            "value": "Payer name"
          }]
        })
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          gap: 2
        },
        children: [/*#__PURE__*/_jsx(TextField, {
          required: true,
          InputProps: {
            readOnly: true
          },
          fullWidth: true,
          label: intl.formatMessage({
            id: "n5QvJy",
            defaultMessage: [{
              "type": 0,
              "value": "Start date"
            }]
          })
        }), /*#__PURE__*/_jsx(TextField, {
          required: true,
          InputProps: {
            readOnly: true
          },
          fullWidth: true,
          label: intl.formatMessage({
            id: "Humfno",
            defaultMessage: [{
              "type": 0,
              "value": "End date"
            }]
          })
        })]
      })]
    }), !hasCustomWrapper && /*#__PURE__*/_jsxs(Stack, {
      height: "100%",
      gap: 2,
      justifyContent: "flex-start",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        sx: {
          width: '340px',
          height: '40%',
          transform: 'none'
        }
      }), /*#__PURE__*/_jsx(Skeleton, {
        sx: {
          width: '340px',
          height: '40%',
          transform: 'none'
        }
      })]
    })]
  });
}